var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[(_vm.error)?_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e(),(_vm.tableMap)?_c('table-map-editor',{attrs:{"table-map":_vm.tableMap,"party":_vm.party,"loading":_vm.loading},on:{"save":_vm.save}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }